import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import SMECustomerSiteMapModel from "../../models/sme-customer-if-site-map/sme-customer-if-site-map.model";
import ViewBase from "../view-base.view";

/**
 * SME Customer I/F Site Map Add-Edit Dialog
 * 
 * The dialog used to add or update records for SME Customer I/F Site Map
 * 
 * @author cmcnkhiep
 */

export default function SMECustomerSiteMapAddEditDialog() {
  ViewBase.call(this);

  const FORM_ID = 'SMECustomerSiteMapAddEditForm';
  const ADD_ACTION = 'ADD';
  const UPDATE_ACTION = 'UPDATE';

  let requestPayload = {};
  let oldSamsungChannel = '';
  let handleCloseDialog = (reload) => { }

  function updatePayload(attr, value) {
    if (Array.isArray(requestPayload[attr])) {
      requestPayload[attr].splice(0, Infinity, ...value);
    } else {
      requestPayload[attr] = value;
    }
  }

  const handleSubmit = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();

    //Trim payload before send request
    Object.entries(requestPayload).forEach(([key, value]) => {
      requestPayload[key] = value.trim();
    })

    SMECustomerSiteMapModel.postSMECustomerSiteMapAction(requestPayload)
      .then((result) => {
        this.showMessage(
          requestPayload.action === ADD_ACTION
            ? this.getText('EM00000797', 'Create Success.')
            : this.getText('EM00000798', 'Update Success.'),
          this.getText('LT00000475', 'Success'),
          () => handleCloseDialog(true)
        );
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: (vnode) => {
      requestPayload = vnode.attrs.updateItem;
      if (requestPayload.action === UPDATE_ACTION) {
        oldSamsungChannel = requestPayload.mapKey;
      }
    },
    view: ({ attrs: { isOpen, onClose, sMECustomerOptions } }) => {
      handleCloseDialog = onClose;
      return m(Dialog,
        {
          isOpen,
          onClose,
          closeOnOutsideClick: false,
          class: 'cui-dialog-lg',
          title: requestPayload.action === ADD_ACTION ? this.getText('LT00000058', 'Create') : this.getText('LT00000128', 'Edit'),
          content: m('container',
            m('.card',
              m('.card-body',
                m('form.needs-validation.row.g-2[novalidate]', { id: FORM_ID, onsubmit: handleSubmit },
                  m('.col-12.position-relative',
                    m('label.form-label.mandatory[for=smeEdiCustomerCode]', this.getText("LT00008046", "Customer")),
                    m(SingleSelectComponent, {
                      id: 'smeEdiCustomerCode',
                      filterable: false,
                      keyOnly: true,
                      required: true,
                      disabled: requestPayload.action === UPDATE_ACTION,
                      items: sMECustomerOptions,
                      selectedItem: requestPayload.smeEdiCustomerCode,
                      onSelect: (selectedItems) => {
                        updatePayload('smeEdiCustomerCode', selectedItems);
                      }
                    }),
                    m('.invalid-tooltip', this.getText('EM00000799', 'Please select Customer'))
                  ),
                  m('.col-12.position-relative',
                    m('label.form-label.mandatory[for="mapKey"]', this.getText("LT00001012", "Samsung Channel")),
                    m('input#mapKey.form-control[name="mapKey"][maxLength="50"]', {
                      placeholder: this.getText("LT00001012", "Samsung Channel"),
                      required: true,
                      value: requestPayload.mapKey,
                      oninput: (e) => {
                        updatePayload('mapKey', e.target.value)
                      }
                    }),
                    m('.invalid-tooltip', this.getText('EM00000800', 'Please input Samsung Channel'))
                  ),
                  m('.col-12.position-relative',
                    m('label.form-label.mandatory[for="mapAttribute1"]', this.getText("LT00001008", "I/F Channel Attr 1")),
                    m('input#mapAttribute1.form-control[name="mapAttribute1"][maxLength="20"]', {
                      placeholder: this.getText("LT00001008", "I/F Channel Attr 1"),
                      required: true,
                      disabled: requestPayload.action === UPDATE_ACTION,
                      value: requestPayload.mapAttribute1,
                      onchange: (e) => {
                        updatePayload('mapAttribute1', e.target.value)
                      }
                    }),
                    m('.invalid-tooltip', this.getText('EM00000801', 'Please input I/F Channel Attr 1'))
                  ),
                  m('.col-12.position-relative',
                    m('label.form-label[for="mapAttribute2"]', this.getText("LT00001009", "I/F Channel Attr 2")),
                    m('input#mapAttribute2.form-control[name="mapAttribute2"][maxLength="20"]', {
                      placeholder: this.getText("LT00001009", "I/F Channel Attr 2"),
                      disabled: requestPayload.action === UPDATE_ACTION,
                      value: requestPayload.mapAttribute2,
                      onchange: (e) => {
                        updatePayload('mapAttribute2', e.target.value)
                      }
                    }),
                  ),
                )
              )
            ),
            this.getBaseViews()
          ),
          footer: m('.d-flex.gap-2.justify-content-end',
            m('button.btn.btn-primary',
              {
                type: 'submit',
                form: FORM_ID,
                disabled: oldSamsungChannel === requestPayload.mapKey.trim()
              },
              this.getText("LT00000022", "Save")
            ),
            m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
          )
        }
      );
    }
  }
}
